import React, { useCallback, useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import { apiRoute, ENUM_INTCAL_OPTION, funValidateNoInput, linksUrl, outTypeEnum } from "../../../constants/enum.js"
import { useFetchWithBody, usePost } from "../../../api/reactQueryCustomHooks.jsx"
import { calculateTotal, convertDate, exportOutStandingInterestReportToPDF, exportOutStandingReportToPDF, getDataSetByGroup } from "../../../Utility/utility.js"
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../../components/index.js"
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE } from "../../../components/NextUITable.jsx"
import { Input, CardBody, Card, Button, Chip, Select, SelectItem, Autocomplete, AutocompleteItem } from "@nextui-org/react"
import { faArrowAltCircleRight, faCalculator, faCalendarDays, faDownload, faRefresh } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { isMobile } from "react-device-detect"

import { resetDetailParams, setIsRediOutstanding } from "../../../state/paymentEntrySlice.jsx"
import { toast } from "react-toastify"


const OutPPartyDetail = () => {
  const navigate = useNavigate()
  const { compCode, compName, endDate, isMultipleCompany } = useSelector((state) => state.company)
  const { menu } = useSelector((state) => state.auth)
  const { currentParty, isFromDashboard } = useSelector((state) => state.outstandingPayable)
 // const [selectedKey, setSelectedKey] = useState([]);
  const [selectedKey, setSelectedKey] = useState(new Set());
  const [data, setData] = useState([]);
  const [diffDueDate, setDiffDueDate] = useState(new Date());
  const [selBroker, setSelBroker] = useState({ key: "", value: "" });
  const dispatch = useDispatch();

  const daysRange = useMemo(
    () =>
      currentParty.remaningDaysRange
        .replace(">", "")
        .replace("=", "")
        .split("<"),
    [currentParty.remaningDaysRange]
  )

  let userMenuComponent = useMemo(
    () =>
      menu?.userMenu?.map((item) => {
        if (item.controller !== null) return item.controller
        else return item.menuname
      }),
    [menu.userMenu]
  )
  const {
    isPending,
    isError,
    data: partyDetail = [],
    mutate: filterData

  } = usePost({
    url: apiRoute.outstanding.partyDetail,
    queryKey: "OutstandingPayablePartyDetail",
  })

  const funloadData = () => {
    filterData({
      data: {
        compcode: compCode.join(","),
        party_id: currentParty.id,
        showAge1: Number(daysRange[0]) ? Number(daysRange[0]) : 0,
        showAge2: Number(daysRange[1]) ? Number(daysRange[1]) : 99999,
        out_type: outTypeEnum.G,
        diff_duedate: new Date(diffDueDate).toISOString().split("T")[0]
      }
    })
  }
  useEffect(() => {
    dispatch(setIsRediOutstanding({ redirect: false, billno: [] }))
    funloadData()
  }, [])

  useEffect(() => {
    setData(partyDetail)
  }, [partyDetail])


  const handleDiffDueDate = () => {
    funloadData();
  }

  const handleResetDate = () => {
    setDiffDueDate(new Date())
    filterData({
      data: {
        compcode: compCode.join(","),
        party_id: currentParty.id,
        showAge1: Number(daysRange[0]) ? Number(daysRange[0]) : 0,
        showAge2: Number(daysRange[1]) ? Number(daysRange[1]) : 99999,
        out_type: outTypeEnum.G,
        diff_duedate: new Date().toISOString().split("T")[0]
      }
    })
  }
  const totalInvAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "inv_amount",
      }),
    [data]
  )
  const totalPayAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "pay_amount",
      }),
    [data]
  )
  const totalBalanceAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "balance_amount",
      }),
    [data]
  )


  let downloadDataFooter = {
    inv_date: "Total",
    inv_no: "",
    inv_amount: totalInvAmount,
    pay_amount: totalPayAmount,
    balance_amount: totalBalanceAmount,
    duedays: "",
    duedate: "",
    diff_days_inv_date: "",
    diff_days_due_date: "",
    compname: "",
  }

  const exportColumns = [
    {
      uid: "inv_date",
      name: "Inv Date",
      type: COLUMN_TYPE.date,
    },
    {
      uid: "inv_no",
      name: "Inv No",
    },
    {
      uid: "inv_amount",
      name: "Inv Amt",
    },
    {
      uid: "pay_amount",
      name: "Pay Amt",
    },
    {
      uid: "balance_amount",
      name: "Balance Amt",
    },

    {
      name: "Due Days",
      uid: "duedays",
    },
    {
      name: "Due Date",
      uid: "duedate",
      type: COLUMN_TYPE.date,
    },
    {
      name: "Diff Days Inv.Dt",
      uid: "diff_days_inv_date",
    },
    {
      name: "Diff Days Due.Dt",
      uid: "diff_days_due_date",
    },
    {
      uid: "compname",
      name: "Company",
    },
  ]

  const fun_RemoveSelection = (selectedBill) => {
    let d = selectedKey.filter(x => selectedBill.indexOf(x) === -1)
    const currentDataIndex = data.findIndex((ele) => ele.transactionid == d[0]);
    if (currentDataIndex >= 0) {
      const updatedData = { ...data[currentDataIndex], int_amount: 0, int_days: data[currentDataIndex].diff_days_due_date };
      const newData = [...data];
      newData[currentDataIndex] = updatedData
      setData(newData)
    }
  }
  const handleClickPrev = () => {
    if (isFromDashboard)
      navigate(linksUrl.dashboard.tradingDashboard)
    else
      navigate(linksUrl.outstanding.payable.partyAgingSummary)
  }

  const handleCheckSelection = useCallback((event) => {
    const { column, e } = event;

    if (e == "all") {
      let arrayAll = []
      data.forEach(ele => {
        arrayAll.push(ele.transactionid)
      });
      setSelectedKey(arrayAll)
    }
    else {
      let selectedBill = Array.from(e);
      let keyList = selectedBill.map(Number)
      if (selectedKey) {
        fun_RemoveSelection(keyList);
      }

      setSelectedKey(keyList);
    }
  }, [selectedKey])

  const INITIAL_VISIBLE_COLUMNS = [
    "inv_date",
    "inv_no",
    "inv_amount",
    "pay_amount",
    "balance_amount",
    "duedays",
    "duedate",
    "diff_days_inv_date",
    "diff_days_due_date",
    "compname",
  ]

  const columns = [
    {
      name: "INV DATE",
      uid: "inv_date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "INV NO",
      uid: "inv_no",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "INV AMOUNT",
      uid: "inv_amount",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalInvAmount,
      },
    },
    {
      name: "PAY AMOUNT",
      uid: "pay_amount",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalPayAmount,
      },
    },

    {
      name: "BAL AMOUNT",
      uid: "balance_amount",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalBalanceAmount,
      },
    },

    {
      name: "Due Days",
      uid: "duedays",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "Due Date",
      uid: "duedate",
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.date,
      sortable: true,
    },
    {
      name: "Diff days/ Inv.Dt",
      uid: "diff_days_inv_date",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "Diff days/ Due.Dt",
      uid: "diff_days_due_date",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "COMPANY",
      align: COLUMN_ALIGN_TYPE.center,
      uid: "compname",
      sortable: true,
    },
  ]

  const {
    isLoading: isAddressPending,
    data: infoData = [],
  } = useFetchWithBody({
    url: apiRoute.outstanding.partyBrokerInfo,
    queryKey: "OutstandingPayablePartySummary-Address",
    inputData: {
      compcode: compCode.join(","),
      party_id: currentParty.id,
    }
  })



  const addReportDataFooter = (tempData) => {
    let downloadReportFooter = {}
    if (Object.keys(downloadReportFooter).length > 0) {
      return [...tempData, downloadReportFooter]
    }
    return tempData
  }



  let downloadReportFooter = {}

  const funCalReportTotal = (filterData) => {
    let totalInvAmount = 0;
    let totalPayAmount = 0;
    let totalBalanceAmount = 0;
    filterData.map((ele) => {
      totalPayAmount += ele.pay_amount;
      totalInvAmount += ele.inv_amount;
      totalBalanceAmount += ele.balance_amount;
    })

    downloadReportFooter = {
      inv_date: "Total",
      inv_no: "",
      inv_amount: totalInvAmount,
      pay_amount: totalPayAmount,
      balance_amount: totalBalanceAmount,
      duedays: "",
      duedate: "",
      diff_days_inv_date: "",
      diff_days_due_date: "",
      compname: "",
    }

    downloadDataFooter = {
      inv_date: "Total",
      inv_no: "",
      inv_amount: totalInvAmount,
      pay_amount: totalPayAmount,
      balance_amount: totalBalanceAmount,
      duedays: "",
      duedate: "",
      diff_days_inv_date: "",
      diff_days_due_date: "",
      compname: "",
    }

  }
  const keysToKeep = ['compname'];

  const groupData = useMemo(() => {
    let fildata = data
    if (selectedKey && selectedKey.size > 0){
     const fildata = data.filter(ele => selectedKey.has(String(ele.transactionid))
);
    console.log(fildata,"fg")
    }
    if (selBroker && selBroker.key != "" && selBroker.key != null) {
      if (selBroker.key == "0")
        fildata = fildata.filter(ele => ele.br_id == '');
      else
        fildata = fildata.filter(ele => ele.br_id == selBroker.key);

    }
    return getDataSetByGroup(fildata)

  }, [data, selectedKey, selBroker])

  const handleOutSReport = () => {

    const groupKey = Object.keys(groupData);
    if (groupKey && groupKey.length > 0) {
      let newData = []
      let totalPayAmount = 0
      let totalInvAmount = 0
      let totalBalanceAmount = 0
      if (groupKey && groupKey.length > 0) {
        for (let i = 0; i < groupKey.length; i++) {
          totalPayAmount = 0
          totalInvAmount = 0
          totalBalanceAmount = 0
          groupData[groupKey[i]].map((ele) => {
            totalPayAmount += ele.pay_amount;
            totalInvAmount += ele.inv_amount;
            totalBalanceAmount += ele.balance_amount;
          })

          const footerData = {
            ...downloadDataFooter, inv_amount: totalInvAmount,
            balance_amount: totalBalanceAmount,
            pay_amount: totalPayAmount,
          }
          const tempData = {
            "broker": groupKey[i], "invoice": addReportDataFooter(groupData[groupKey[i]]),
            "footerData": isMultipleCompany ? footerData :
              Object.fromEntries(
                Object.entries(footerData).filter(([key, value]) => !keysToKeep.includes(key)))
          }
          newData = [...newData, tempData]

        }

      }
      exportOutStandingReportToPDF({
        data: newData, //addReportDataFooter(exportData),
        downloadFileName: "Payable_Outstanding_Report",
        reportTitle: `Payable Outstanding ${endDate && endDate != "" ? "Up To " + convertDate(new Date(endDate).toISOString().split("T")[0]) : ""} For ${currentParty.name}`,
        downloadDataFooter: {},
        downloadBillDetail: {},
        exportColumns: isMultipleCompany ? exportColumns : exportColumns.filter((ele) => ele.uid != 'compname'),
        downloadFileheader: {
          "party": currentParty.name, "company": compName,
          "address": infoData && infoData.addData.length > 0 ? infoData.addData[0]?.Party_Address : "",
          "broker": ""
        },

      })
    }
    else {
      toast.error("No Data Found", {
        "position": "top-center"
      })
    }

  }

  const handleBrokerChange = (val) => {
    const filData = infoData.brokerData.filter(ele => ele.Party_Id == val)
    if (filData && filData.length > 0)
      setSelBroker({ key: val, value: filData[0].Party_Name })
    else
      setSelBroker({ key: val, value: "" })

  }


  const handleEntry = () => {
    dispatch(resetDetailParams())
    let selBillNo = []
    if (selectedKey && selectedKey.size > 0) {
      const fildata = data.filter(ele => selectedKey.has(String(ele.transactionid)));
      selBillNo = fildata.map(ele => ele.inv_no)
    }
    dispatch(setIsRediOutstanding({ redirect: true, billno: selBillNo }))
    navigate(linksUrl.transaction.paymentEntry.createEntry)
  }
  const handleSelectionChange = (payload) => {


    const { e } = payload;

    // 🔥 CASE 1: Select all
    if (e === "all") {
      const allKeys = data.map((row) => String(row.transactionid));
      setSelectedKey(new Set(allKeys));
      return;
    }

    // 🔥 CASE 2: empty selection
    if (!e) {
      setSelectedKey(new Set());
      return;
    }

    // 🔥 CASE 3: if Set
    if (e instanceof Set) {
      setSelectedKey(e);
      return;
    }

    // 🔥 CASE 4: array
    if (Array.isArray(e)) {
      setSelectedKey(new Set(e));
      return;
    }

    // 🔥 CASE 5: fallback (single value or object)
    if (typeof e === "string" || typeof e === "number") {
      setSelectedKey(new Set([e]));
      return;
    }

    console.warn("Unknown selection format:", e);

  };
  if (isPending) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer
        pageName="Party Detail"
        info={[
          ["Party", currentParty.name],
          ["Aging", currentParty.remaningDaysRange],
        ]}
        breadcrumbs={["Payable", "Party Detail"]}
        prevPage={{
          show: true,
          onClick: handleClickPrev,
        }}
      >
        {/* <Card shadow="sm" radius="sm" className="mb-3 h-full">
          <CardBody className="p-2">
            <div className="flex items-center gap-2 w-full ">

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={"Due Date"}
                  views={["day", "month", "year"]}
                  format="DD/MM/YYYY"
                  value={
                    diffDueDate
                      ? dayjs(diffDueDate)
                      : diffDueDate
                  }
                  onChange={(newValue) => {
                    setDiffDueDate(dayjs(newValue).format("YYYY-MM-DD"))
                  }}
                  className={`${isMobile ? "max-w-28" : "w-auto"}  font-semibold`}
                  slotProps={{ textField: { size: "small" } }}
                />

              </LocalizationProvider>

              <Button onPress={handleDiffDueDate} color="success" size="sm" className={`${isMobile ? "w-auto" : ""}  text-sm`}
                startContent={<FontAwesomeIcon icon={faRefresh} />} >Refresh</Button>
              <Button onPress={handleResetDate} color="warning" size="sm" className={`${isMobile ? "w-auto" : ""}  text-sm`}
                startContent={<FontAwesomeIcon icon={faCalendarDays} />} >Reset Date </Button>

            </div>
           
          </CardBody>
        </Card> */}

        <div className={`w-full flex  ${isMobile ? "flex-wrap" : ""}  ${userMenuComponent?.includes('ReceiveEntryMaster') ? "justify-between" : "justify-end"} text-right mb-2`}>
          {userMenuComponent?.includes('PaymentEntryMaster') && compCode.length==1 ?
            <div className={`${isMobile ? "order-1" : ""}`}>
              <Chip onClick={handleEntry} color="warning" radius="sm" size="sm" variant="shadow" className=" cursor-pointer"
              > <FontAwesomeIcon icon={faArrowAltCircleRight} className="mr-2" />Payment Entry</Chip></div>
            : ''}
          <div className={`${isMobile ? "justify-between order-1 mt-2" : "justify-end "} gap-4 w-full flex items-center align-top `}>
            <Autocomplete
              className={`${isMobile ? "w-auto" : "max-w-xs"}  font-semibold`}
              size="sm"
              label="Broker"
              placeholder={""}
              //labelPlacement="outside"
              variant="flat"
              color="primary"
              defaultItems={infoData && infoData?.brokerData ? infoData.brokerData : []}
              onSelectionChange={handleBrokerChange}
              selectedKey={selBroker.key}
            >{
                (item) => {
                  return (
                    <AutocompleteItem key={item.Party_Id}>{item.Party_Name}</AutocompleteItem>
                  )
                }
              }

            </Autocomplete>
            <Button onPress={handleOutSReport} color="primary" size="sm" className={`${isMobile ? "max-w-2xl" : "max-w-36"}  text-sm`}
              startContent={<FontAwesomeIcon icon={faDownload} />} >OutStanding</Button>

          </div>
        </div>
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          rowSelection={true}
          downloadFileName="Payable_Outstanding_Detail"
          showAdvanceFilter={false}
          //handleSelectionChange={handleCheckSelection}
           handleSelectionChange={handleSelectionChange}
          selectedKeys={selectedKey}
          setSelectedKeys={setSelectedKey}
          id="transactionid"
        />

      </MainContainer>
    </div>
  )
}

export default OutPPartyDetail
